// Onboarding content configuration
// This file contains all copy for the dealer onboarding flow
// Content teams can easily update text without touching component code

import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';

import type React from 'react';

export interface OnboardingContentCard {
	icon: React.ComponentType<{ className?: string; fontSize?: 'small' | 'medium' | 'large' }>;
	title: string;
	subtitle: string;
}

export interface OnboardingPageContent {
	navigationTitle: string;
	pageTitle: string;
	subtitle: string;
	pageNumber: number;
	contentCards?: OnboardingContentCard[];
}

export interface OnboardingContent {
	[key: number]: OnboardingPageContent;
}

export enum OnboardingPage {
	HowEkhoWorks = 1,
	PricingValue = 2,
	InventoryConnection = 3,
	BusinessDetails = 4,
	BankAccount = 5,
	Access = 6,
	Completion = 7,
}

export const onboardingContent: OnboardingContent = {
	[OnboardingPage.HowEkhoWorks]: {
		navigationTitle: 'How It Works',
		pageTitle: 'How Ekho Works For Dealers',
		subtitle:
			'List inventory, receive leads, and power effortless online sales—all with no IT lift.',
		pageNumber: 1,
		contentCards: [
			{
				icon: RocketLaunchOutlinedIcon,
				title: 'Free to get started!',
				subtitle:
					'List your inventory and receive leads at no cost. Only pay when we fully process a sale 100% online.',
			},
		],
	},
	[OnboardingPage.PricingValue]: {
		navigationTitle: 'Pricing & Value',
		pageTitle: "Ekho's Pricing & Value",
		subtitle:
			'No upfront costs. No recurring fees. Pay the equivalent of a doc fee only when we process a sale for you.',
		pageNumber: 2,
		contentCards: [
			// {
			// 	icon: DynamicFormOutlinedIcon,
			// 	title: 'Inventory Listing',
			// 	subtitle: 'List unlimited inventory on our marketplace at no cost',
			// },
			// {
			// 	icon: PeopleAltOutlinedIcon,
			// 	title: 'Lead Generation',
			// 	subtitle: 'Receive qualified leads and inquiries from interested buyers.',
			// },
			// {
			// 	icon: PeopleAltOutlinedIcon,
			// 	title: 'Online Sales',
			// 	subtitle: 'Only charged when a complete online sale is processed via Ekho.',
			// },
			// {
			// 	icon: AttachMoneyOutlinedIcon,
			// 	title: 'F&I Revenue',
			// 	subtitle:
			// 		'Earn 70% of all online sale F&I and dealer reserve proceeds without lifting a finger.',
			// },
			// {
			// 	icon: AttachMoneyOutlinedIcon,
			// 	title: 'Dealer Reserve',
			// 	subtitle:
			// 		'Earn 70% of all Ekho sale dealer reserve proceeds without lifting a finger.',
			// },
			// {
			// 	icon: AttachMoneyOutlinedIcon,
			// 	title: 'Pre-Paid Credit',
			// 	subtitle:
			// 		'Due today, and pre-pays for X sales processed through Ekho over the next 12 months.',
			// },
		],
	},
	[OnboardingPage.InventoryConnection]: {
		navigationTitle: 'Inventory Data',
		pageTitle: 'Connect your Data Sources',
		subtitle: 'Link your DMS and website to sync inventory automatically.',
		pageNumber: 3,
	},
	[OnboardingPage.BusinessDetails]: {
		navigationTitle: 'Dealership Details',
		pageTitle: 'Dealership Details',
		subtitle:
			'We need this info to create your account. You can always update these in your Ekho Portal after onboarding.',
		pageNumber: 4,
	},
	[OnboardingPage.BankAccount]: {
		navigationTitle: 'Bank Account',
		pageTitle: 'Bank Account',
		subtitle:
			'We need this info to create your account. You can always update these in your Ekho Portal after onboarding.',
		pageNumber: 5,
	},
	[OnboardingPage.Access]: {
		navigationTitle: 'Access',
		pageTitle: 'Access',
		subtitle:
			'Specify who will have access to your portal. Enter email addresses for yourself and up to 2 additional team members. At least one email is required.',
		pageNumber: 6,
	},
	[OnboardingPage.Completion]: {
		navigationTitle: "You're Live!",
		pageTitle: "You're Live!",
		subtitle:
			"You're all set! Your dealership is now ready to start receiving leads and processing online sales.",
		pageNumber: 7,
	},
};

// Header content
export const headerContent = {
	title: 'Dealer Onboarding',
	subtitle: 'Welcome, {name}!',
};
